module.exports = __webpack_public_path__ + "img/hotel.79ea7eb7.svg";